import React, { ReactNode } from 'react';
import { Add } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';

interface Props {
  tabTitle: ReactNode;
  listSlot: ReactNode;
  actionName?: string;
  action?: VoidFunction;
  filterSlot?: ReactNode;
}

export const TabContainer = ({ tabTitle, listSlot, filterSlot, action, actionName }: Props) => {
  return (
    <Stack gap="1.5rem" height="calc(100% - 6rem)">
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        {typeof tabTitle === 'string' ? (
          <Typography variant="h6" component="span">
            {tabTitle}
          </Typography>
        ) : (
          tabTitle
        )}

        {action && actionName && (
          <Button startIcon={<Add />} variant="contained" onClick={action}>
            {actionName}
          </Button>
        )}
      </Stack>

      {filterSlot}
      {listSlot}
    </Stack>
  );
};
